export default __webpack_public_path__ + "static/media/client6.448b7808.jpeg";